export default __webpack_public_path__ + "static/service-residential-fiber-581fc0c1178fc1021636e688444d1816.jpg";